import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { Link } from "react-router-dom";
import { gatepassadd, gatepassdelete, gatepassList } from "../../../api/GatePassService";
import Swal from "sweetalert2";
import { getBatchList } from "../../../api/BatchService";
import { closeModal, formatTime, ToastMain ,SweetAlertShow} from "../../master/Master";

import { useNavigate } from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import { StudentList } from "../../../api/StudentServices";
import { imgBaseUrl } from "../../../api/api";
import StudentHeader from "../../students/v2/StudentHeader";
import { enquiryList } from "../../../api/Enquiry";

function GatePass() {
  const instituteData = JSON.parse(localStorage.getItem("setting")) || {};
  const Session = JSON.parse(localStorage.getItem("activeSesson")) || {};
  const [gatepass, setGatepass] = useState([]);
  const [filter, setFilter] = useState({ date: "", class: "", batch: "" });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [course_id, setCourseId] = useState("");
  const [session_id, setSessionId] = useState("");
  const [selectedSession, setSelectedSessions] = useState('');
  const [sessions, setSessions] = useState([]);
  const [batches, setBatches] = useState([]);
  const [batchId, setBatchID] = useState("");
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [data, setData] = useState('');
  const [type, setType] = useState('');
  const [modalData, setModalData] = useState('');
  const [page, setPage] = useState(1);
  const [date, setDate] = useState('');
  const [pagination, setPagination] = useState('');
  const [search, setSearch] = useState('');
  const [formData, setFormData] = useState({
    type: '',
    batch_ids: '',
    student_id: '',
    enquiry_id: '',
    reason: '',
    time: '',
    date: ''
  });
  const [studentType, setStudentType] = useState('');
  const id = modalData
  // alert('modal data id' + id)


  const fetchGetPass = async () => {
    let addUrl = '';

    if (batchId) addUrl += `&batch_id=${batchId}`;
    if (page) addUrl += `&page=${page}`;
    if (date) addUrl += `&date=${date}`;
    if (search) addUrl += `&search=${search}`;

    setLoading(true);
    try {
      const response = await gatepassList(addUrl);
      if (response?.data?.status) {
        setGatepass(response?.data?.data?.data);
        setPagination(response?.data?.data)
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow('info','Warning', response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    }
    setLoading(false);
  };

  const fetchUpdateGatePass = async (id) => {
    try {
      const response = await gatepassList(id);
      const data = response?.data?.data?.data?.[0];
      if (data) {
        setFormData({
          type: data?.type?.toString() || '',
          batch_ids: data?.batch_id || '',
          student_id: data?.student_id || '',
          enquiry_id: data?.enquiry_id || '',
          reason: data?.reason || '',
          time: data?.time || '',
          date: data?.date || ''
        });
        setStudentType(data.type?.toString() || '');
      }
    } catch {
      Swal.fire('Error', 'Failed to fetch gate pass data.', 'error');
    }
  };

  useEffect(() => {
    if (id) {
      fetchUpdateGatePass(id);
    }
  }, [id])


  const handleDelete = (id) => {
    // setLoading(true); // Show loading spinner

    // Show a confirmation dialog before deleting
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Await the deletion operation
          const response = await gatepassdelete(id);

          if (response?.status) {
            Swal.fire('Deleted!', response.data.message, 'success');
            fetchGetPass(); // Refresh the list after successful deletion
          } else {
            Swal.fire({
              icon: 'success',
              title: 'Deleted successfully',
              timer: 1000,
            });
            fetchGetPass(); // Refresh the list
          }
        } catch (error) {
          Swal.fire('Error', 'Failed to delete: ' + (error?.message || 'Unknown error'), 'error');
          fetchGetPass(); // Refresh the list even after an error
        }
      } else {
        // If cancelled, no action is performed
        Swal.fire('Cancelled', 'Your data is safe :)', 'info');
      }
      setLoading(false); // Hide loading spinner
    });
  };


  useEffect(() => {
    fetchGetPass();
  }, [batchId, page, date, search]);

  const getBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`
    setLoading(true);
    try {
      let response = await getBatchList(addUrl);

      setBatches(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSession = async () => {
    setLoading(true)
    try {
      const response = await getSessions();
      if (response?.data?.status) {

        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getSession();
    getBatches();
  }, []);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const formData = new FormData(e.target);
      const data = formData;
      const response = await gatepassadd(data);
      if (response?.data?.status) {
        closeModal('createGatepass')
        e.target.reset();
        ToastMain.fire({
          icon: 'success',
          title: response?.data?.message || 'something went wrong'
        }).then(() => {
          fetchGetPass();
        })
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors);
        }
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (erorr) {
      if (erorr?.response?.data?.errors) {
        setError(erorr?.response?.data?.errors);
      }
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error',error?.response?.data?.message ?? erorr?.message)
    } finally {
      setLoading(false)
    }
  };
  const StudentFetch = async () => {
    try {
      setLoading(true);
      let response = null;

      if (type == "1") {
        const addUrl = `&batch_id=${batchId}`;
        response = await StudentList(addUrl);
      } else {
        const addUrl = `&batch_id=${batchId}`;
        response = await enquiryList(addUrl);
      }

      if (response?.data?.status) {
        const list = response?.data?.data?.data || [];
        setData(list);

        // ToastMain.fire({
        //   icon: "success",
        //   title: response?.data?.message || "List fetched successfully",
        // });
      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });

        SweetAlertShow('info','Warning',response?.data?.message)
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Failed to fetch data",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    StudentFetch();
  }, [type, batchId]);

const handlePrint = (entry, instituteData, imgBaseUrl, Session, formatTime) => {
  const printWindow = window.open("", "_blank");
  printWindow.document.write(`
  <html>
    <head>
      <title>Gate Pass</title>
      <style>
        body {
          font-family: 'Arial', sans-serif;
          background: #fff;
          margin: 0;
          padding: 25px;
          color: #000;
          position: relative;
        }
        .gatepass {
          border: 1.5px solid #009688;
          padding: 20px 25px;
          width: 90%;
          margin: 0 auto;
          position: relative;
          overflow: hidden;
        }

        /* ===== WATERMARK ===== */
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-25deg);
          font-size: 40px;
          color: rgba(0, 0, 0, 0.05);
          white-space: nowrap;
          pointer-events: none;
          z-index: 0;
          font-weight: 700;
          text-transform: uppercase;
          text-align: center;
        }

        .header {
          display: flex;
          align-items: center;
          border-bottom: 1.5px solid #009688;
          padding-bottom: 10px;
          position: relative;
          z-index: 2;
        }
        .logo {
          flex: 0 0 90px;
        }
        .logo img {
          width: 80px;
          height: 80px;
          object-fit: contain;
        }
        .school-info {
          flex: 1;
          text-align: center;
          line-height: 1.4;
        }
        .school-info h2 {
          margin: 0;
          font-size: 20px;
          color: #000;
          font-weight: bold;
        }
        .school-info p {
          margin: 2px 0;
          font-size: 13px;
          color: #333;
        }
        .gatepass-title {
          text-align: center;
          font-weight: bold;
          text-decoration: underline;
          font-size: 15px;
          margin: 10px 0;
          position: relative;
          z-index: 2;
        }
        .details {
          font-size: 14px;
          line-height: 1.8;
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          position: relative;
          z-index: 2;
        }
        .col {
          width: 50%;
          padding: 5px 10px;
          box-sizing: border-box;
        }
        .details strong {
          color: #000;
        }
        .footer-line {
          border-top: 1.5px solid #009688;
          margin-top: 15px;
          position: relative;
          z-index: 2;
        }
        .sign-row {
          display: flex;
          justify-content: space-between;
          text-align: center;
          margin-top: 25px;
          font-size: 13px;
          position: relative;
          z-index: 2;
        }
        .sign-box {
          width: 20%;
        }
        .sign-box button {
          background: #1976d2;
          color: #fff;
          border: none;
          padding: 3px 10px;
          font-size: 12px;
          border-radius: 3px;
        }
        .manoj {
          color: red;
          font-weight: bold;
        }

        @media print {
          body { margin: 0; }
          .watermark { color: rgba(0, 0, 0, 0.08); }
        }
      </style>
    </head>
    <body>
      <div className="gatepass">
        <!-- Watermark -->
        <div className="watermark">${(instituteData?.name || "SCHOOL ERP SOFTWARE").toUpperCase()}</div>

        <div className="header">
          <div className="logo">
            <img src="${instituteData?.logo_img
              ? `${imgBaseUrl}${instituteData.logo_img}`
              : "/files/logo.png"
            }" alt="School Logo" />
          </div>
          <div className="school-info">
            <h2>${instituteData?.name || "SCHOOL ERP SOFTWARE"}</h2>
            <p>${instituteData?.address || 
              `${instituteData?.village || ""}, ${instituteData?.district || ""} (${instituteData?.state || ""})`}</p>
            <p>Contact : ${instituteData?.mobile || ""} | Email : ${instituteData?.email || ""}</p>
            <p>Session : ${Session?.session || ""}</p>
          </div>
        </div>

        <div className="gatepass-title">GATE PASS</div>

        <div className="details">
          <!-- Left Column -->
          <div className="col">
            <p>Reg No.: <strong>${entry?.student?.registration_no || "N/A"}</strong></p>
            <p>Student Name: <strong>${entry?.student?.name || "N/A"}</strong></p>
            <p>Father Name: <strong>${entry?.student?.father_name || "N/A"}</strong></p>
            <p>Gender: <strong>${entry?.student?.gender || "N/A"}</strong></p>
          </div>

          <!-- Right Column -->
          <div className="col">
            <p>Mobile: <strong>${entry?.student?.phone || "N/A"}</strong></p>
            <p>Address: <strong>${entry?.student?.village || "N/A"}</strong></p>
            <p>Date: <strong>${entry?.date || ""}</strong></p>
            <p className="manoj">Out Time: <strong>${formatTime(entry?.time) || ""}</strong></p>
          </div>

          <p className="manoj" style="width:100%;"><strong>Reason:</strong> ${entry?.reason || "N/A"}</p>
        </div>

        <div className="footer-line"></div>

        <div className="sign-row">
          <div className="sign-box"><button>Parent Sign</button></div>
          <div className="sign-box">Student Sign</div>
          <div className="sign-box">Security Sign</div>
          <div className="sign-box">Class Teacher Sign</div>
          <div className="sign-box">HOD Sign</div>
        </div>
      </div>

      <script>
        window.print();
        window.onafterprint = function() { window.close(); }
      </script>
    </body>
  </html>
  `);
  printWindow.document.close();
};







  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
           
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
               
           <div className="col-md-2 left-pane">
             <StudentHeader data={'Student Portal'}/>
           </div>

                <div className="col-md-10 right-pane">
                  <div className="card shadow mb-4">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h3 className="text-primary">Gate Pass</h3>
                      <button
                        className="btn btn-primary btn-sm d-inline-flex align-items-center overflow-hidden  transition-button"
                        data-bs-toggle='modal'
                        data-bs-target='#createGatepass'
                      >
                        <span className="icon">+</span>
                        <span className="text ms-2">Create Gate Pass</span>
                      </button>

                    </div>
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="col-md-3 form-floating form-floating-outline">
                          <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
                          <label className="">Date</label>
                        </div>

                        <div className="col-md-3 form-floating form-floating-outline mb-6">
                          <select
                            name="batch_id"
                            className="form-select"
                            value={batchId}
                            onChange={(e) => setBatchID(e.target.value)}
                          >
                            <option value="">All Batch</option>
                            {batches?.map((batch, i) => {
                              const courseTitle = batch?.course?.title || "";
                              const shortCourseTitle =
                                courseTitle.length > 20
                                  ? courseTitle.substring(0, 20) + "..."
                                  : courseTitle;

                              return (
                                <option key={i} value={batch?.id}>
                                  {`${batch?.title} (${shortCourseTitle})`}
                                </option>
                              );
                            })}
                          </select>
                          <label htmlFor="">Select Batch</label>
                        </div>
                        <div className="col-md-3 form-floating form-floating-outline">
                          <input type="text" className="form-control" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
                          <label className="">Search</label>
                        </div>
                        <div className="col-md-3 col-sm-5">
                          <button type="submit" className="btn btn-label-primary me-1">
                            <i className="ri-arrow-right-line ri-20px" />
                          </button>
                          <a href="?" className="btn btn-label-danger me-1">
                            <i className="ri-restart-line ri-20px" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card p-3">
                    {/* {JSON.stringify(gatepass)} */}
                    {/* <h6 >Gate Pass Entries</h6> */}
                    <div className="table-responsive">
                      <table className="table  mt-3 text-center table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>#</th>
                            <th>Student</th>
                            <th>Batch</th>
                            <th>Date</th>
                            <th>Out Time</th>
                            <th>Reason</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(gatepass) && gatepass.length > 0 ? (
                            gatepass.map((entry, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td className="text-primary fw-bold">{entry?.student?.name || 'N/A'}</td>
                                <td>{entry?.batch?.title || 'N/A'}</td>
                                <td>{entry?.date}</td>
                                <td>{formatTime(entry?.time)}</td>
                                <td>{entry?.reason}</td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    {/* <Link to="/CreateGateUpdate" className="btn btn-primary btn-sm mx-2 mt-1" state={{ id: entry.id }}>
                                    <i className="bi bi-pencil-square text-white"></i>
                                  </Link> */}
                                    {/* <button className="btn btn-sm btn-outline-primary me-1" data-bs-toggle='modal' data-bs-target='#updateGatepass' onClick={(e) => setModalData(entry?.id)}>Edit</button> */}
                                    {/* <button className="btn btn-danger btn-sm mt-1" onClick={() => handleDelete(entry.id)}><i className="bi bi-trash-fill"></i></button> */}
                                    <button
                                      className="btn btn-sm btn-outline-primary ms-2 mt-1"
                                      onClick={() => handlePrint(entry, instituteData, imgBaseUrl, Session,formatTime)}
                                    >
                                      <i className="bi bi-printer"></i>
                                    </button>

                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8">No entries found.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <nav aria-label="Page navigation" className="mt-10">
                        <p>
                          Showing {pagination?.from} to {pagination?.to} of{" "}
                          {pagination?.total} entries
                        </p>
                        <ul className="pagination pagination-sm">
                          {pagination?.links?.map((btn, i) => (
                            <li
                              className={`page-item  ${btn?.active && "active"
                                }  ${btn?.url ? "" : "disabled"} `}
                            >
                              <button
                                className="page-link waves-effect"
                                onClick={() => {
                                  if (pagination?.links?.length === i + 1) {
                                    btn?.url &&
                                      setPage(pagination?.current_page + 1);
                                  } else if (i === 0) {
                                    btn?.url &&
                                      setPage(pagination?.current_page - 1);
                                  } else {
                                    setPage(btn.label);
                                  }
                                }}
                              >
                                {pagination?.links?.length == i + 1 ? (
                                  <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                ) : i == 0 ? (
                                  <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                ) : (
                                  btn?.label
                                )}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </nav>
                    </div>

                  </div>
                </div>
             

                </div>
                
                </div>
          
            
            </div>
        </div></div>

      <div
        className="modal fade"
        id="createGatepass"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-label-primary py-3 ">
                <h1 className="modal-title fs-5">Gate Pass Create</h1>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">


                <div className="row mb-3">
                  <div className="col-md-4 form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="type"

                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="">Select Type</option>
                      <option value="1">Admitted Students</option>
                      <option value="0">Enquiry Students</option>
                    </select>
                    <label className="">Student Type</label>
                    <span className="text-danger">{error?.type ?? ''} </span>


                  </div>

                  <div className="col-md-4 form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="batch_id"
                      value={batchId}
                      onChange={(e) => setBatchID(e.target.value)}

                    >
                      <option value="">Select Batch</option>
                      {batches?.map((batch, i) => {
                        const courseTitle = batch?.course?.title || "";
                        const shortCourseTitle =
                          courseTitle.length > 20
                            ? courseTitle.substring(0, 20) + "..."
                            : courseTitle;

                        return (
                          <option key={i} value={batch?.id}>
                            {`${batch?.title} (${shortCourseTitle})`}
                          </option>
                        );
                      })}
                    </select>
                    <label className="">Batch</label>
                    <span className="text-danger">{error?.batch_id ?? ''} </span>

                  </div>

                  <div className="col-md-4">
                    {type === "1" && (
                      <div className="mt-0 form-floating form-floating-outline">
                        <select className="form-select" name="student_id" >
                          <option value="">Select Student</option>
                          {Array.isArray(data) &&
                            data.map((stu, index) => (
                              <option key={index} value={stu.id}>
                                {stu.name}
                              </option>
                            ))}
                        </select>
                        <label>Student</label>
                        <span className="text-danger">{error?.student_id ?? ''} </span>

                      </div>
                    )}

                    {type === "0" && (
                      <div className="mt-2 form-floating form-floating-outline">
                        <select className="form-select" name="enquiry_id" >
                          <option value="">Select Enquiry Student</option>
                          {Array.isArray(data) &&
                            data.map((en, index) => (
                              <option key={index} value={en.id}>
                                {en.student_name}
                              </option>
                            ))}
                        </select>
                        <label>Enquiry Student</label>
                        <span className="text-danger">{error?.enquiry_id ?? ''} </span>

                      </div>
                    )}
                  </div>
                </div>

                {/* Reason and Time */}
                <div className="row">
                  <div className="col-md-4 form-floating form-floating-outline">
                    <textarea
                      className="form-control input-uppercase"
                      name="reason"
                      placeholder="Enter reason for gate pass"

                    ></textarea>
                    <label className="">Reason</label>
                    <span className="text-danger">{error?.reason ?? ''} </span>
                  </div>


                  <div className="col-md-4 form-floating form-floating-outline">
                    <input
                      type="time"
                      className="form-control"
                      name="time"

                    />
                    <label>Time</label>
                    <span className="text-danger">{error?.time ?? ''} </span>
                  </div>
                  <div className="col-md-4 form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      name="date"

                    />
                    <label>Date</label>
                    <span className="text-danger">{error?.date ?? ''} </span>

                  </div>
                </div>


              </div>
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  ) : (
                    'Submit'
                  )}
                  {loading ? ' Submitting...' : ''}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>



      <div
        className="modal fade"
        id="updateGatepass"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header bg-label-primary py-3 ">
                <h1 className="modal-title fs-5">Gate Pass Update</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>

              <div className="modal-body">
                {JSON.stringify(formData)}

                <div className="row mb-3">
                  {/* ✅ Type Select */}
                  <div className="col-md-4 form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="type"
                      value={formData.type}
                      onChange={(e) =>
                        setFormData({ ...formData, type: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Type</option>
                      <option value="1">Admitted Students</option>
                      <option value="0">Enquiry Students</option>
                    </select>
                    <label>Student Type</label>
                    <span className="text-danger">{error?.type ?? ""}</span>
                  </div>

                  {/* ✅ Batch Select */}
                  <div className="col-md-4 form-floating form-floating-outline">
                    <select
                      className="form-select"
                      name="batch_id"
                      value={formData.batch_ids}
                      onChange={(e) =>
                        setFormData({ ...formData, batch_ids: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Batch</option>
                      {batches?.map((batch, i) => {
                        const courseTitle = batch?.course?.title || "";
                        const shortCourseTitle =
                          courseTitle.length > 20
                            ? courseTitle.substring(0, 20) + "..."
                            : courseTitle;

                        return (
                          <option key={i} value={batch?.id}>
                            {`${batch?.title} (${shortCourseTitle})`}
                          </option>
                        );
                      })}
                    </select>
                    <label>Batch</label>
                    <span className="text-danger">{error?.batch_id ?? ""}</span>
                  </div>

                  {/* ✅ Student or Enquiry Dropdown */}
                  <div className="col-md-4">
                    {formData.type === "1" && (
                      <div className="mt-0 form-floating form-floating-outline">
                        <select
                          className="form-select"
                          name="student_id"
                          value={formData?.student_id}
                          onChange={(e) =>
                            setFormData({ ...formData, student_id: e.target.value })
                          }
                          required
                        >
                          <option value="">Select Student</option>
                          {Array.isArray(data) &&
                            data.map((stu, index) => (
                              <option key={index} value={stu.id}>
                                {stu.name}
                              </option>
                            ))}
                        </select>
                        <label>Student</label>
                        <span className="text-danger">{error?.student_id ?? ""}</span>
                      </div>
                    )}

                    {formData.type === "0" && (
                      <div className="mt-2 form-floating form-floating-outline">
                        <select
                          className="form-select"
                          name="enquiry_id"
                          value={formData.enquiry_id}
                          onChange={(e) =>
                            setFormData({ ...formData, enquiry_id: e.target.value })
                          }
                          required
                        >
                          <option value="">Select Enquiry Student</option>
                          {Array.isArray(data) &&
                            data.map((en, index) => (
                              <option key={index} value={en.id}>
                                {en.student_name}
                              </option>
                            ))}
                        </select>
                        <label>Enquiry Student</label>
                        <span className="text-danger">{error?.enquiry_id ?? ""}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* ✅ Reason, Time, Date */}
                <div className="row">
                  <div className="col-md-4 form-floating form-floating-outline">
                    <textarea
                      className="form-control input-uppercase"
                      name="reason"
                      value={formData.reason}
                      onChange={(e) =>
                        setFormData({ ...formData, reason: e.target.value })
                      }
                      placeholder="Enter reason for gate pass"
                      required
                    ></textarea>
                    <label>Reason</label>
                    <span className="text-danger">{error?.reason ?? ""}</span>
                  </div>

                  <div className="col-md-4 form-floating form-floating-outline">
                    <input
                      type="time"
                      className="form-control"
                      name="time"
                      value={formData.time}
                      onChange={(e) =>
                        setFormData({ ...formData, time: e.target.value })
                      }
                      required
                    />
                    <label>Time</label>
                    <span className="text-danger">{error?.time ?? ""}</span>
                  </div>

                  <div className="col-md-4 form-floating form-floating-outline">
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={formData.date}
                      onChange={(e) =>
                        setFormData({ ...formData, date: e.target.value })
                      }
                      required
                    />
                    <label>Date</label>
                    <span className="text-danger">{error?.date ?? ""}</span>
                  </div>
                </div>
              </div>

              {/* ✅ Footer */}
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    </>
  );
}
export default GatePass;